import { Container } from "../../components/layout/Container.jsx";
import { PageHero } from "../../components/shared/PageHero.jsx";
import { InquiryForm } from "../../components/forms/InquiryForm.jsx";
import { SEO } from "../../lib/seo.jsx";

export default function NewBuildContactPage() {
  return (
    <>
      <SEO
        title="New Build Enquiry"
        description="Talk to our design team about your new build — block, brief, and budget."
      />

      <PageHero
        eyebrow="New build"
        title="Tell us about your project"
        description="A few details now means we come to the first call already prepped — block size, suburb, budget bracket, and what you've already shortlisted."
      />

      <Container className="py-16 lg:py-20">
        <div className="mx-auto max-w-2xl rounded-2xl border border-border-subtle bg-bg-elevated p-8">
          <InquiryForm
            formType="new_build"
            successMessage="Thanks — our design team will be in touch within one business day."
          />
        </div>
      </Container>
    </>
  );
}
